const config =  {
  apiGateway: {
    REGION: "eu-central-1",
    URL: "https://vbyscealp2.execute-api.eu-central-1.amazonaws.com/prod"
  },
};
export default config;